import { render, staticRenderFns } from "./TemplateCurso.vue?vue&type=template&id=0eeeecfb&"
import script from "./TemplateCurso.vue?vue&type=script&lang=js&"
export * from "./TemplateCurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CursosShowBanner: require('/opt/buildhome/repo/components/Cursos/Show/Banner.vue').default,CursosShowSobreOCurso: require('/opt/buildhome/repo/components/Cursos/Show/SobreOCurso.vue').default,CursosShowSobreOCursoCards: require('/opt/buildhome/repo/components/Cursos/Show/SobreOCursoCards.vue').default,CursosShowCompetencias: require('/opt/buildhome/repo/components/Cursos/Show/Competencias.vue').default,CursosShowEquipe: require('/opt/buildhome/repo/components/Cursos/Show/Equipe.vue').default,CursosShowComponenteCurricular: require('/opt/buildhome/repo/components/Cursos/Show/ComponenteCurricular.vue').default,CursosShowCoordenadores: require('/opt/buildhome/repo/components/Cursos/Show/Coordenadores.vue').default,CursosShowBannerExtra: require('/opt/buildhome/repo/components/Cursos/Show/BannerExtra.vue').default,CursosShowDiferenciaisCurso: require('/opt/buildhome/repo/components/Cursos/Show/DiferenciaisCurso.vue').default,CursosFluxograma: require('/opt/buildhome/repo/components/Cursos/Fluxograma.vue').default,HomeContato: require('/opt/buildhome/repo/components/Home/Contato.vue').default,CursosCarousel: require('/opt/buildhome/repo/components/Cursos/Carousel.vue').default})
